import store from 'store'
import get from 'lodash/get'

export function getDictonary(locale) {
  try {
    return require(`react-intl/locale-data/${getDictonaryName(locale)}`)
  } catch (error) {
    console.log(`Cannot find ${locale} directory`)
  }
}

export function getDictonaryName(locale) {
  if (!locale) {
    return 'en'
  }

  let dictonaryToLoad = locale

  if (locale.includes('_')) {
    dictonaryToLoad = locale.split('_')[0]
  }

  if (locale.includes('-')) {
    dictonaryToLoad = locale.split('-')[0]
  }

  return dictonaryToLoad
}

export function toDash(locale) {
  if (!locale) {
    return
  }

  let dictonaryToLoad = locale

  if (locale.includes('_')) {
    dictonaryToLoad = locale.replace('_', '-')
  }

  return dictonaryToLoad
}

export function toUnderscore(locale) {
  if (!locale) {
    return
  }

  let dictonaryToLoad = locale

  if (locale.includes('-')) {
    dictonaryToLoad = locale.replace('-', '_')
  }

  return dictonaryToLoad
}

export const getLocaleFromStore = () => {
  try {
    const storedLocale = store.get('locale')

    if (get(storedLocale, 'code')) {
      return storedLocale
    } else if (storedLocale) {
      return JSON.parse(storedLocale)
    }
  } catch (err) {
    console.log(err)
  }
}

export function getLocaleOnServer(req) {
  if (req.query.locale) {
    return { code: req.query.locale }
  }

  return req.cookies.locale ? JSON.parse(req.cookies.locale) : null
}

